import type { RouteRecordRaw } from 'vue-router';
import DataPortalLayout from './layouts/DataPortalLayout.vue';
// Registers the data portal messages with the app i18n instance.
import './i18n';

export const dataPortalRoutes: RouteRecordRaw = {
  path: '/data-portal',
  component: DataPortalLayout,
  meta: { authDomain: 'data-portal' },
  children: [
    {
      path: 'login',
      name: 'data-portal-login',
      component: () => import('./views/DataPortalLoginView.vue'),
      meta: { dataPortalPublic: true },
    },
    {
      path: '',
      name: 'data-portal-home',
      component: () => import('./views/DataPortalHomeView.vue'),
      meta: { requiresDataPortalAuth: true },
    },
    {
      path: 'views',
      name: 'data-portal-views',
      component: () => import('./views/DataViewsView.vue'),
      meta: { requiresDataPortalAuth: true },
    },
    {
      path: 'views/:viewKey',
      name: 'data-portal-view-details',
      component: () => import('./views/DataViewDetailsView.vue'),
      meta: { fillViewport: true, requiresDataPortalAuth: true },
    },
    {
      path: 'admin/protokolle',
      name: 'data-portal-audit',
      component: () => import('./views/DataPortalAuditView.vue'),
      meta: {
        fillViewport: true,
        requiresDataPortalAuth: true,
        requiresDataPortalAdmin: true,
      },
    },
    {
      path: 'admin/sichten',
      name: 'data-portal-admin-views',
      component: () => import('./views/admin/DataPortalAdminViewsView.vue'),
      meta: { requiresDataPortalAuth: true, requiresDataPortalAdmin: true },
    },
    {
      path: 'admin/sichten/:viewKey',
      name: 'data-portal-admin-view',
      component: () =>
        import('./views/admin/DataPortalAdminViewEditorView.vue'),
      meta: { requiresDataPortalAuth: true, requiresDataPortalAdmin: true },
    },
    {
      path: 'admin/dwh-freigaben',
      name: 'data-portal-admin-allowlist',
      component: () => import('./views/admin/DataPortalAdminAllowlistView.vue'),
      meta: { requiresDataPortalAuth: true, requiresDataPortalAdmin: true },
    },
    {
      path: 'admin/benutzer',
      name: 'data-portal-admin-users',
      component: () => import('./views/admin/DataPortalAdminUsersView.vue'),
      meta: { requiresDataPortalAuth: true, requiresDataPortalAdmin: true },
    },
    {
      path: 'forbidden',
      name: 'data-portal-forbidden',
      component: () => import('./views/DataPortalForbiddenView.vue'),
      meta: { dataPortalPublic: true },
    },
    {
      path: 'unavailable',
      name: 'data-portal-unavailable',
      component: () => import('./views/DataPortalUnavailableView.vue'),
      meta: { dataPortalPublic: true },
    },
    {
      path: ':pathMatch(.*)*',
      name: 'data-portal-not-found',
      component: () => import('./views/DataPortalNotFoundView.vue'),
      meta: { dataPortalPublic: true },
    },
  ],
};
